import { createAuthBindings, type UserWithSettings } from '@w/auth-fe'
import { s } from '@w/schema'

export const flashcardsUserSettingsSchema = s.object({
  lexicon: s
    .object({
      nativeLanguage: s.string().optional(),
    })
    .optional(),
  // page-views.spec.md: false stops recording this member's page views.
  showViewHistory: s.boolean().optional(),
})

export type FlashcardsUserSettings = s.infer<
  typeof flashcardsUserSettingsSchema
>
export type FlashcardsUser = UserWithSettings<FlashcardsUserSettings>

const authBindings = createAuthBindings({
  userSettingsSchema: flashcardsUserSettingsSchema,
})

export const createAuthClient: typeof authBindings.createAuthClient = (
  config,
) => authBindings.createAuthClient(config)
